import styled from 'styled-components'

import { bh, hrColor } from '../../utils/style-utils'
import withCondition from '../withCondition'

export default withCondition(styled.hr`
  border: 1px dashed ${hrColor};
  margin: ${(p) => (p.sm ? bh * 0.75 : bh * 1.25)}px 0;
`)
